// extracted by mini-css-extract-plugin
export var services = "Services-module--services--1Ka0b";
export var imgwrap = "Services-module--imgwrap--2QpUC";
export var services_section = "Services-module--services_section--3cLis";
export var title = "Services-module--title--3HYzi";